import { render, staticRenderFns } from "./DropzoneUploadedFile.vue?vue&type=template&id=764695f0"
import script from "./DropzoneUploadedFile.vue?vue&type=script&lang=js"
export * from "./DropzoneUploadedFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports